import { marketSearchApi } from '@envato/foundation-types'

// our sorting is not ideal and it sometimes gets it wrong.
// Apparently some used versions are not structured properly.
// So a quick solution was to just filter things that cause issues
const problematicVerionKeys = ['Drupal 6.x']

const sortReverseVersion = (nodes?: marketSearchApi.IFilterTreeNode[]) => {
  return (nodes || [])
    .filter(node => problematicVerionKeys.indexOf(node.key) === -1)
    .map(node => ({ semverValue: getSemverValue(node.key), node }))
    .sort((entry1, entry2) =>
      entry1.semverValue > entry2.semverValue ? -1 : 1
    )
    .map(entry => entry.node)
}

const getSemverValue = (key: string) => {
  let versionString = key.split(' ').pop() as string
  versionString = versionString
    .replace(/\.x/g, '99')
    .replace(/x/g, '99')
    .replace('.', '_DOT_')
    .replace('.', '')
    .replace('_DOT_', '.')

  return parseFloat(versionString)
}

export default sortReverseVersion
